import React from 'react';
import StyledLabel from '../styled-label';
import VehicleReservationGenericSummary from './vehicle-reservation-generic-summary';
import VehicleReservationPill from './vehicle-reservation-pill';
import { sectionShape, vehicleReservationDataShape } from './prop-types';

const namespace = 'vehicle-reservation-with-credit';

const VehicleReservation = ({ title, values, creditData, creditPill }) => (
  <div className={namespace}>
    <VehicleReservationPill data={creditPill} />
    <div className={`${namespace}__title-container`}>
      <StyledLabel className={`${namespace}__title`} color={title?.title?.color} as="span">
        {title?.title?.text}
      </StyledLabel>
    </div>
    <ul className={`${namespace}__values`} color="primary" size="m">
      {title?.subtitles?.map(item => (
        <li key={item.text}>
          <StyledLabel className={`${namespace}__label`} color={item.color} as="span">
            {item.text}
          </StyledLabel>
        </li>
      ))}
    </ul>
    <div className={`${namespace}__title-container`}>
      <StyledLabel className={`${namespace}__title`} color={values?.title?.color} as="span">
        {values?.title?.text}
      </StyledLabel>
    </div>
    <ul className={`${namespace}__values`} color="primary" size="m">
      {values?.subtitles?.map(item => (
        <li key={item?.text}>
          <StyledLabel className={`${namespace}__label`} color={item?.color} as="span">
            {item?.text}
          </StyledLabel>
        </li>
      ))}
    </ul>
    {creditData && <VehicleReservationGenericSummary data={creditData} />}
  </div>
);

VehicleReservation.propTypes = {
  title: sectionShape.isRequired,
  values: sectionShape.isRequired,
  creditData: vehicleReservationDataShape,
  creditPill: vehicleReservationDataShape,
};

export default VehicleReservation;
